import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const myStyles = (): any =>
  makeStyles((theme: Theme) =>
    createStyles({
      customlink: (props: any) => ({
        display: 'flex',
        '& > *': {
          margin: theme.spacing(1),
        },
        '& a': {
          color: props?.disabled ? '#c4c4c4' : '#5b5b5b',
          cursor: 'pointer',
          padding: '2px 12px',
          borderRadius: 4,
        },
      }),
      link: (props: any) => {
        if (props?.variant) {
          return {
            '&.selected': {
              backgroundColor: props?.disabled
                ? 'transparent'
                : theme.palette.primary.main,
              color: props?.disabled ? '#c4c4c4' : '#fff',
              boxShadow: 'unset',
            },
            '&:hover': {
              backgroundColor: props?.disabled
                ? 'transparent'
                : theme.palette.primary.main,
              color: props?.disabled ? '#c4c4c4' : '#fff',
              boxShadow: 'unset',
              textDecoration: props?.disabled ? 'none' : 'unset',
              cursor: props?.disabled ? 'not-allowed' : 'pointer',
            },
            padding: 0,
            fontSize: 14,
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.57,
            letterSpacing: 'normal',
            textTransform: 'unset',
            backgroundColor: 'unset',
            boxShadow: 'unset',
          };
        }
        if (props?.simplelink && props.simplelink === 'true') {
          return {
            '&.selected': {
              backgroundColor: props?.disabled
                ? 'transparent'
                : theme.palette.primary.main,
              color: props?.disabled ? '#c4c4c4' : '#fff',
              boxShadow: 'unset',
            },
            '&:hover': {
              color: props?.disabled ? '#c4c4c4' : theme.palette.primary.main,
              opacity: 0.8,
              boxShadow: 'unset',
              textDecoration: props?.disabled ? 'none' : 'unset',
              cursor: props?.disabled ? 'not-allowed' : 'pointer',
            },
            padding: '12px 0 !important',
            margin: '0px !important',
            fontSize: 14,
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.57,
            letterSpacing: 'normal',
            textTransform: 'unset',
            backgroundColor: 'unset',
            boxShadow: 'unset',
            color: `${theme.palette.primary.main} !important`,
          };
        }
        return {
          '&.selected': {
            background: 'unset',
            color: props?.disabled ? '#c4c4c4' : theme.palette.primary.main,
            boxShadow: 'unset',
          },
          '&:hover': {
            background: 'unset',
            color: props?.disabled ? '#c4c4c4' : theme.palette.primary.main,
            boxShadow: 'unset',
            textDecoration: props?.disabled ? 'none' : 'inherit',
            cursor: props?.disabled ? 'not-allowed' : 'pointer',
          },
          fontSize: 14,
          fontWeight: 'normal',
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 1.57,
          letterSpacing: 'normal',
          backgroundColor: 'unset',
          boxShadow: 'unset',
        };
      },
    }),
  );
